import createIcon from '../../createIcon';

/**
 * @component @name DriveFileRenameOutline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTZMMTEgMjBIMjFWMTZIMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIuMDYgNy4xOUwzIDE2LjI1VjIwSDYuNzVMMTUuODEgMTAuOTRMMTIuMDYgNy4xOVpNNS45MiAxOEg1VjE3LjA4TDEyLjA2IDEwLjAyTDEyLjk4IDEwLjk0TDUuOTIgMThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTguNzEgOC4wNEMxOS4xIDcuNjUgMTkuMSA3LjAyIDE4LjcxIDYuNjNMMTYuMzcgNC4yOUMxNi4xNyA0LjA5IDE1LjkyIDQgMTUuNjYgNEMxNS40MSA0IDE1LjE1IDQuMSAxNC45NiA0LjI5TDEzLjEzIDYuMTJMMTYuODggOS44N0wxOC43MSA4LjA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DriveFileRenameOutline = createIcon('DriveFileRenameOutline', [
  ['path', { d: 'M15 16L11 20H21V16H15Z', key: 'oa0j0o' }],
  [
    'path',
    {
      d: 'M12.06 7.19L3 16.25V20H6.75L15.81 10.94L12.06 7.19ZM5.92 18H5V17.08L12.06 10.02L12.98 10.94L5.92 18Z',
      key: 'wr4h3x',
    },
  ],
  [
    'path',
    {
      d: 'M18.71 8.04C19.1 7.65 19.1 7.02 18.71 6.63L16.37 4.29C16.17 4.09 15.92 4 15.66 4C15.41 4 15.15 4.1 14.96 4.29L13.13 6.12L16.88 9.87L18.71 8.04Z',
      key: '5b6a5l',
    },
  ],
]);

export default DriveFileRenameOutline;
